import classNames from 'classnames';

import type {
  ApiGifvAttachmentJSON,
  ApiImageAttachmentJSON,
  ApiVideoAttachmentJSON,
} from '@/flavours/glitch/api_types/media_attachments';
import { Blurhash } from '@/flavours/glitch/components/blurhash';
import type { MediaAttachmentShape } from '@/flavours/glitch/models/status';

import classes from './content.module.scss';

type StatusImageAttachmentJSON =
  | ApiImageAttachmentJSON
  | ApiGifvAttachmentJSON
  | ApiVideoAttachmentJSON;

export const StatusImage: React.FC<
  {
    attachment:
      | StatusImageAttachmentJSON
      | MediaAttachmentShape<StatusImageAttachmentJSON>;
    children?: React.ReactNode;
    sensitive?: boolean;
  } & React.ComponentPropsWithRef<'div'>
> = ({ attachment, children, sensitive, className, style, ...props }) => {
  let x = 50;
  let y = 50;
  const focusX = attachment.meta?.focus?.x;
  const focusY = attachment.meta?.focus?.y;
  if (focusX && focusY) {
    x = (focusX / 2 + 0.5) * 100;
    y = (focusY / -2 + 0.5) * 100;
  }

  const width = attachment.meta?.original?.width;
  const height = attachment.meta?.original?.height;

  const imgStyle = {
    backgroundImage:
      !sensitive && attachment.preview_url
        ? `url(${attachment.preview_url})`
        : undefined,
    backgroundPosition: `${x}% ${y}%`,
    '--aspect': width && height ? `${width} / ${height}` : undefined,
    ...style,
  };

  return (
    <div
      {...props}
      className={classNames(classes.image, className)}
      style={imgStyle}
      data-color-scheme='dark'
    >
      {sensitive && attachment.blurhash && (
        <Blurhash hash={attachment.blurhash} className={classes.blurHash} />
      )}

      {children}
    </div>
  );
};
